<template>
  <div class="muteng-result-container">
    <img class="logo" src="/static/images/muteng/logo.png" />
    <div v-if="showContent === 1" class="content">
      <img class="zhen-img" src="/static/images/muteng/zhen.png" />
    </div>
    <div class="content" v-if="showContent === 2" >
      <div class="rule-box">
        <div class="rule-top">
          <img src="/static/images/muteng/thanks.png" class="rule-title-img" />
        </div>
        <div class="rule-bottom">
          <div class="rule-claim">
            <img src="/static/images/muteng/claim-points.png" class="claim-points-img" />
          </div>
          <div class="rule-shop" @click="toClaim">
            <img src="/static/images/muteng/get-jf.png" class="shop-img" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="showContent === 2" class="footer-text" @click="toRule">规则说明</div>
  </div>
</template>

<script>
import { getAntiResult, getTemplateV2, getJoinDataByCodeDirect, getWechatAuth } from '../../api/api'

export default {
  name: 'MuTengResult',
  data() {
    return {
      eno: process.env.ENV_NUM === '1' ? '138595604458' : '138316896007',
      code: '',
      antiCode: '',
      deptId: '',
      activityId: '',
      showContent: 0,
      appId: process.env.ENV_NUM === '1' ? 'wxc537e3c625581d97' : 'wxbc22565b3e7a59fd',
    }
  },
  methods: {
    async queryAntiResult(code) {
      const res = await getAntiResult(code)
      return res && res.data ? res.data : {}
    },
    async checkIsJoined(code) {
      const res = await getJoinDataByCodeDirect({ 
        code: code,
        enterpriseNo: this.eno
      })
      return res && res.data ? res.data : {}
    },
    async initQuery(code) {
      try {
        const data = await this.queryAntiResult(code)
        if (data.code === '300101' || data.code === '300102') {
          if (data.data) {
            this.deptId = data.data.deptId
            this.antiCode = data.data.code
            const res = await getTemplateV2(this.deptId, this.antiCode)
            const templateData = res && res.data && res.data.data ? res.data.data : null
            
            let isActivityActive = false
            if (templateData && templateData.activityId && templateData.enabled !== 0) {
              const now = new Date().getTime()
              const begin = new Date(templateData.beginTime.replace(/-/g, '/')).getTime()
              const end = new Date(templateData.endTime.replace(/-/g, '/')).getTime()
              if (now >= begin && now <= end) {
                isActivityActive = true
              }
            }

            if (!isActivityActive) {
              this.showContent = 1
              console.log('无活动')
            } else {
              this.activityId = templateData.activityId
              const joinRes = await this.checkIsJoined(this.antiCode)
              if (joinRes.code === '500001') {
                this.showContent = 1
              } else if (joinRes.code === '200') {
                this.showContent = 2
              } else {
                this.showContent = 1
              }
            }
          }
        } else if (data.code === '300106') {
          alert('数码不存在，谨防仿冒')
        } else {
          alert('查询异常，请稍后再试')
        }
      } catch (err) {
        alert('查询异常，请稍后再试')
        console.log(err)
      }
    },
    toRule() {
      this.$router.push({
        path: '/muteng/rule',
        query: {
          deptId: this.deptId,
          code: this.antiCode
        }
      })
    },
    toClaim() {
      const redirectUrl = window.location.origin + '/muteng/claimResult'
      const params = new URLSearchParams()
      params.append('eno', this.eno)
      params.append('c', this.antiCode)
      params.append('deptId', this.deptId)
      params.append('code', this.antiCode)

      const fullRedirectUrl = redirectUrl + '?' + params.toString()

      getWechatAuth(encodeURIComponent(fullRedirectUrl), this.appId, 1).then(res => {
        const data = res.data
        window.location.href = data
      }).catch(err => {
        alert('获取微信授权失败' + err)
      })
    }
  },
  async mounted() {
    const params = this.$route.query;
    await this.initQuery(params.c)
  }
}
</script>

<style scoped>
.muteng-result-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #000;
  background-image: url('/static/images/muteng/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.logo {
  position: absolute;
  top: 5vh;
  right: 7vw;
  width: 35vw;
  z-index: 10;
}

.content {
  position: relative;
  z-index: 5;
}

.rule-box {
  position: absolute;
  top: 65vh;
  left: 50%;
  transform: translateX(-50%);
  width: 80vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rule-top {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 2vh;
}

.rule-title-img {
  width: 55vw;
}

.rule-bottom {
  width: 100%;
  display: flex;
  margin-top:1vh;
  justify-content: space-between;
  align-items: flex-end;
}

.rule-claim {
  flex: 1;
  padding-right: 2vw;
}

.claim-points-img {
  width: 35vw; /* 减小宽度，从 50vw 调整为 40vw */
  display: block;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.rule-text {
  flex: 1;
  color: #ffffff;
  font-size: 2.8vw;
  line-height: 1.6;
  text-align: left;
  padding-right: 2vw;
}

.rule-text p {
  margin: 0.5vh 0;
}

.shop-img {
  width: 15vw;
  display: block;
}

.zhen-img {
  position: absolute;
  top: 74vh;
  left: 10vw;
  width: 50vw;
}

.footer-text {
  position: absolute;
  bottom: 3vh;
  left: 50%;
  transform: translateX(-50%);
  color: #ffffff;
  cursor: pointer;
  font-size: 3.5vw;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/MuTeng/Result.vue